import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor( private authService: AuthService, private router: Router){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree { 
      //return true is somebody is logged in only

      const newUserAuthKey = localStorage.getItem('newUserAuthKey');
      if (newUserAuthKey) {
        return true;
      } else{
        Swal.fire('Info', 'Sorry, you need to login first to proceed', 'info');
        this.router.navigate(['/api-login']);
        return false;
        
      }

      }
  
}
